import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { QuizAttemptsDialogData } from '@edtech-ui/core/models/admin-student-platform/admin-user-management';

@Component({
  selector: 'app-dialog-quiz-attempts',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './dialog-quiz-attempts.component.html',
  styleUrl: './dialog-quiz-attempts.component.scss'
})
export class DialogQuizAttemptsComponent {

  @Input() data!: QuizAttemptsDialogData;
  @Output() close = new EventEmitter<void>();

  closeModal() {
    this.close.emit();
  }

  getBadgeClass(score: number): string {
    if (score >= 80) return 'score-high';
    if (score >= 50) return 'score-mid';
    return 'score-low';
  }
}
